import { LogParams } from '../localeParams'

const logsJA: LogParams = {
  success: {
    created: '作成されました',
  },
  error: {
    failed: '失敗しました',
  },
  installer: {
    welcomeMsg: '🔥 ソラナバリデーターツール solv へようこそ 🔥',
    description: 'あなたはもう、ソラナバリデーターになる準備ができています。',
  },
}

export default logsJA
